var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:[
    _vm.iconClass,
    `icon-container--${_vm.variant}`,
    `icon-container--${_vm.size}`,
    {
      'mr-1': _vm.marginRight,
      'cursor-pointer': _vm.clickable,
    },
  ],on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }